// extracted by mini-css-extract-plugin
export default {"prestation":"style_prestation__ep3HL","header":"style_header__e+qBB","body":"style_body__-0Y3u","notConnected":"style_notConnected__xb7nc","footer":"style_footer__Bq1aG"};